module.exports = __webpack_public_path__ + "img/cover.5906e31f.jpg";